import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, switchMap, catchError, EMPTY, of } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { ConfigService } from '@services/config.service';
import { environment } from 'src/environments/environment';
import { MANUAL_TOKEN_KEY } from '@constants/auth.constants';

@Injectable()
export class MsalApiTokenInterceptor implements HttpInterceptor {
  private readonly config = inject(ConfigService);
  private readonly msalService = inject(MsalService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(this.config.apiEndpoint)) {
      return next.handle(req);
    }

    if (localStorage.getItem(MANUAL_TOKEN_KEY)) {
      return next.handle(req);
    }

    let account = this.msalService.instance.getActiveAccount();
    if (!account) {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length > 0) {
        account = accounts[0];
        this.msalService.instance.setActiveAccount(account);
      }
    }

    if (!account) {
      return next.handle(req);
    }

    const scopes = environment.auth.msalConfig?.apiScopes ?? ['user.read'];
    const resolvedAccount = account;

    return from(
      this.msalService.instance.acquireTokenSilent({ scopes, account: resolvedAccount })
    ).pipe(
      catchError((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          this.msalService.instance.acquireTokenRedirect({ scopes, account: resolvedAccount });
          return EMPTY;
        }
        console.error('[MsalApiTokenInterceptor] acquireTokenSilent failed:', error);
        return of(null);
      }),
      switchMap((result) => {
        if (!result) {
          return next.handle(req);
        }
        return next.handle(
          req.clone({ setHeaders: { Authorization: `Bearer ${result.accessToken}` } })
        );
      })
    );
  }
}
